module.exports = __webpack_public_path__ + "static/media/main.f07693b9.png";